import { useState } from 'react';
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { 
    Card, CardContent, CardActions, Typography, TextField, Button, Dialog, 
    DialogTitle, DialogContent, DialogActions,
} from '@mui/material';

const LoginPage = () => {
    const [mobile, setMobile] = useState('');
    const [message, setMessage] = useState('');
    const [userType, setUserType] = useState('');
    const navigate = useNavigate();
   
    const { login } = useAuth(); 
    const [open, setOpen] = useState(false); 

    const apiUrl = 'https://script.google.com/macros/s/AKfycbwar8XqOffGD-8_e1wIDuHIUUq1zuiqLfYKH00wrrTxhbdGNFgQVWNpRcvAqKpt1RxMYA/exec';

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage('');
        setUserType('');

        try {
            const response = await fetch(`${apiUrl}?action=validate&mobile=${encodeURIComponent(mobile)}`);
            const data = await response.json();

            if (data.status === 'success') {
                const userData = { mobile, role: data.user_type };
                login(userData); 
                
                   // Store user details in localStorage
                localStorage.setItem("user_type", data.user_type);
                localStorage.setItem("first_name", data.first_name);
                // Save user in state and localStorage
                localStorage.setItem("mobile", mobile);
                navigate("/landing"); 
                setMessage(data.message);
                setUserType(data.user_type);
            } else {
                setMessage('Invalid mobile number.');
            }
        } catch (error) {
            setMessage('Error validating mobile number.');
            console.error('Error:', error);
           
        }
        setOpen(true);
    };

    return (
        <div className='bg-[#f8f9e9]' style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>           
            <Card  sx={{ backgroundColor:"#F8F9E9", width: { xs: "90%", sm: "80%", md: 350 }, padding: 2, border: "2px solid", borderColor: "#CEC35E", boxShadow: 3 }}>
                <CardContent >
                    <Typography variant="h5" component="div" align="center" gutterBottom className='text-[#E52029]'>
                        Login Detail
                    </Typography>

                    <form onSubmit={handleSubmit} > 
                        <TextField
                            label="Mobile Number"
                            placeholder="Enter Mobile Number"
                            type="number"
                            variant="outlined"
                            fullWidth
                            margin="normal"
                            value={mobile}
                            onChange={(e) => setMobile(e.target.value)}
                            inputProps={{ maxLength: 10, pattern: "[0-9]*" }}
                            onInput={(e) => e.target.value = e.target.value.replace(/\D/g, '').slice(0, 10)}
                            
                            required
                        />
                        
                        <CardActions style={{ justifyContent: 'center' }}>
                            <Button 
                                type="submit" 
                                variant="contained" 
                                color="error"                                
                                className="text-white py-2 px-4 rounded hover:bg-green-700"                                 
                                fullWidth
                            >
                                LOGIN
                            </Button>
                        </CardActions>
                    </form>
                    <a href="/help" style={{ color: "blue", fontWeight: "500" }}>Help? </a>

                </CardContent>
            </Card>
            <Dialog open={open} onClose={() => setOpen(false)}>
                <DialogTitle>Response</DialogTitle>
                <DialogContent>
                    <p>{message} </p>
                   
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpen(false)} color="primary">Close</Button>
                </DialogActions>
            </Dialog>           
            {/* {message && <p>{message} {userType && ` - User Type: ${userType}`}</p>} */}

             
        </div>
    );
};

export default LoginPage;